// removed by extract-text-webpack-plugin
module.exports = {"sel_sl_ul":"_2HIjbP0TMHTeK2JbOrquho","img_a":"_1oU7xukYu0WBOuzrbRYVen","col_0":"_1TPb9oFpHAc06o3t-jUP8W","col_1":"CULP07aV2iSO66gkPredX","col_2":"_2GHttNbprXNtfYhrthjASC","banerActive":"_1qATQ1NoDcxOkWSqHg55cp","img_b":"_1_tAwyCXH_8Cxqy7G_EJ7M","wid":"_2Y9zx7tzYQdhdyxU7jAZ2n","wid_1":"_2cgcXfwiM5CEIVbaKS8mYq"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MainSearchPageMiddleChangeComponent/MainSearchPageMiddleChangeComponent.scss
 ** module id = 991
 ** module chunks = 0
 **/